import { Component, Input, TemplateRef } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";

@Component({
    selector: "eff-popover",
    templateUrl: "./eff-popover.component.html",
    styleUrls: ["./eff-popover.component.scss"],
    imports: [MatMenuModule, NgTemplateOutlet]
})
export class EffPopoverComponent {
    @Input() popoverContentTemplate: TemplateRef<any>;
    @Input() popoverButtonTemplate: TemplateRef<any>;
    @Input() data: any;
    @Input() panelClass: string;

    onClick(event) {
        event.stopPropagation();
    }
}
